import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import { Grid,CardHeader, Paper, Stack, Tooltip, } from '@mui/material';
import call from 'src/core/services/http';
import { toast } from 'react-toastify';
import Page from "src/shared/components/Page";
import CheckboxComponent from 'src/shared/components/checkbox';
import Title from 'src/shared/Text/Title';
import AuthService from 'src/core/access-control/AuthService';
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useNavigate } from "react-router-dom";
import { getOperators } from "../../../shared/reducers/users/SharedUsersAction";


const IndividualFormSchema = Yup.object().shape({
  mobile_number: Yup.string().required("Required"),

});


const Signatory = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [data, setData] = useState({
    checker_approval_required: false,
    signatory_approval_required: false,
  });
  const [loading, setLoading] = useState(true);
  const merchantId = AuthService.getUserId();
  const [shop] = useLocalStorage('shop-details');


  const defaultValues = {
    "mobile_number": "mobile_number",
    "savings_account_id": "shop.id",

  };


  const methods = useForm({
    resolver: yupResolver(IndividualFormSchema),
    defaultValues,
    mode: 'onChange'
  });

  const {
    handleSubmit, getValues, setValue, reset,
    formState: { isSubmitting },
  } = methods;


  const [state, setState] = useState(defaultValues)
 


  const getSettings = async () => {
    try {
      const response = await call('get', `/merchants/${merchantId}/savings-accounts/${shop.id}/account-settings/`);
      if (response.data.status) {
        setData(response.data.account_settings);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);

  const handleCheckerApprovalChange = async () => {
    try {
      const response = await call('post', `/merchants/${merchantId}/savings-accounts/${shop.id}/account-settings/checker-settings/`, {
        is_approval_required: !data.checker_approval_required,
      });
      if (response.data.status) {
        setData((prevData) => ({
          ...prevData,
          checker_approval_required: !data.checker_approval_required,
        }));
        toast.success('Checker approval updated successfully');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSignatoryApprovalChange = async () => {
    try {
      const response = await call('post', `/merchants/${merchantId}/savings-accounts/${shop.id}/account-settings/signatory-settings/`, {
        is_approval_required: !data.signatory_approval_required,
      });
      if (response.data.status) {
        setData((prevData) => ({
          ...prevData,
          signatory_approval_required: !data.signatory_approval_required,
        }));
        toast.success('Signatory approval updated successfully');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };



  const { users } = useSelector(state => state.sharedUser)

  const getUsers = () => {
    let payload = {
      merchantId: AuthService.getUserId(),
      savingsId: shop.id
    }

    dispatch(getOperators(payload))
  }


  useEffect(() => {
    getUsers()
  }, [dispatch])


  return (
    <Page title='Shop Settings'>
      <Grid container spacing={3}>
  
      <Grid item xs={12} md={10} lg={10} spacing={2}>
          <Paper variant="outlined" sx={{ py: 2, textAlign: 'center', height: 370, px: 20 }}>
            <CardHeader
              title={<Title variant={'subtitle2'} text='Shop Settings' sx={{ mb: 6 }} />}
            />
            <Stack spacing={3}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography gutterBottom variant="button" paragraph>
                  Require Signatory Approval
                </Typography>
                <Stack direction="row" spacing={3} alignItems="center">
                  <Tooltip
                    title="Require transactions to be approved by signatories in the system. Click the button on the right to turn on/off"
                    placement="bottom"
                    arrow
                  >
                    <Typography
                      sx={{
                        color: "#fff",
                        background: "#000",
                        textAlign: "center",
                        width: 20,
                        height: 20,
                        borderRadius: 50,
                        marginLeft: 4
                      }}
                    >
                      ?
                    </Typography>
                  </Tooltip>
                  <CheckboxComponent
                    acceptText="Turned Off"
                    negateText="Turned On"
                    checked={data.signatory_approval_required}
                    handleChange={handleSignatoryApprovalChange}
                    loading={loading}
                    key="Signatory Approval"
                  />
                </Stack>
              </Stack>

              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography gutterBottom variant="button" paragraph>
                  Require Checker Approval
                </Typography>
                <Stack direction="row" spacing={3} alignItems="center">
                  <Tooltip
                    title="Require transactions to be approved by checkers in the system. Click the button on the right to turn on/off"
                    placement="bottom"
                    arrow
                  >
                    <Typography
                      sx={{
                        color: "#fff",
                        background: "#000",
                        textAlign: "center",
                        width: 20,
                        height: 20,
                        borderRadius: 50,
                        marginLeft: 4
                      }}
                    >
                      ?
                    </Typography>
                  </Tooltip>

                  <CheckboxComponent
                    acceptText="Turned Off"
                    negateText="Turned On"
                    checked={data.checker_approval_required}
                    handleChange={handleCheckerApprovalChange}
                    loading={loading}
                    key="Checker Approval"
                  />
                </Stack>
              </Stack>
            </Stack>
          </Paper>
        </Grid>
        <Grid item xs={12} md={8} lg={10} spacing={2}>
        </Grid>
      </Grid>
    </Page>
  )
}

export default Signatory;
